<template>
  <div class="header_frame common_frame">
    <div>
      <img src="../../../static/img/common/logo.png" @click="to_first" />
      <div class="header_right">
        <img
          src="../../../static/img/common/remind.png"
          alt=""
          class="cursor img"
          @click="to_news"
        />
        <!-- 头像图 -->
        <img
          :src="personLists.avatar"
          alt=""
          class="cursor head head_img"
          @click="to_PersonCenter"
          v-if="personLists != ''"
        />
        <span @click="to_login" class="cursor" v-else>登录</span>
      </div>
      <div class="search f12">
        <input
          type="text"
          placeholder="搜索资讯/视频/方案"
          v-model="searchValue"
          @blur="hidefocus"
          @click="showfocus"
        />
        <button class="f12 cursor" @click="search">搜索</button>
        <!-- <div class="header_search" v-if="ISshow">
          <img
            src="../../../static/img/common/close.png"
            alt=""
            class="header_close"
            @click="close_show"
          />

          <div class="f12 search_title" v-if="History.length != 0">
            历史记录
          </div>
          <div
            class="f12 search_content"
            v-for="(item, index) in History"
            @click="getValue(item)"
            v-if="History.length != 0"
          >
            {{ item }}
          </div>
          <div class="f12 search_title">热门搜索</div>
          <div
            class="f12 search_content"
            v-for="(item, index) in REMENLIST"
            @click="getValue(item)"
          >
            {{ item }}
          </div>
        </div> -->
      </div>

      <ul class="f16 c03">
        <div
          @click="to_home"
          :class="actives == '首页' ? 'link router-link-active' : 'link'"
        >
          首页
        </div>
        <div
          class="link"
          @click="updates"
          :class="actives == '选型计算' ? 'link router-link-active' : 'link'"
        >
          选型计算
        </div>
        <div
          :class="actives == '直线模组' ? 'link router-link-active' : 'link'"
          @click="linecen('all')"
        >
          直线模组
          <div class="header_box f14">
            <div
              @click.stop="linecen(item.id)"
              v-for="(item, index) in goodtab"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div
          @click="solution_lists(tabData[0].id,tabData[0].name)"
          :class="actives == '解决方案' ? 'link router-link-active' : 'link'"
        >
          解决方案
          <div class="header_box f14">
            <div
              @click.stop="solution_lists(item.id, item.name)"
              v-for="(item, index) in tabData"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div
          class="link"
          @click="news_list('newsall', '新闻中心')"
          :class="actives == '新闻中心' ? 'link router-link-active' : 'link'"
        >
          新闻中心

          <div class="header_box f14">
            <div
              @click.stop="news_list(item.id, item.name)"
              v-for="(item, index) in tablist"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div
          @click="to_service"
          :class="actives == '服务与支持' ? 'link router-link-active' : 'link'"
        >
          服务与支持
        </div>
        <div
          @click="about_list(105, '公司简介')"
          :class="actives == '关于我们' ? 'link router-link-active' : 'link'"
        >
          关于我们
          <div class="header_box f14">
            <div
              @click.stop="about_list(item.id, item.name)"
              v-for="(item, index) in aboutData"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  removeToken,
  getToken,
  setToken_history,
  getToken_history,
  removeToken_history,
  getToken_user,
} from "@/utils/auth";
import { columnlist, goodsList } from "@/api/api";
import router from "../../router/index";

export default {
  name: "headers",
  data() {
    return {
      personLists: "",
      id: "",
      ids: "",
      oid: "",
      cid: "",
      names: "",
      name: "",
      oname: "",
      searchValue: "",
      REMENLIST: [],
      History: [],
      history: "",
      tablist: "",
      tabData: "",
      aboutData: "",
      goodtab: "",
      token: "",
      ISshow: false,
    };
  },
  methods: {
    //去登陆页
    to_login() {
      // window.open("https://www.faster-motion.com/index.html#/login",'_blank')
      this.common.to_login(this);
    },
    //跳转首页
    to_first() {
      this.$router.push({ name: "first" });
    },
    to_PersonCenter() {
      this.$router.push({ name: "PersonCenter" });
    },
    //个人信息
    personData() {
      if (getToken()) {
        // this.personListsAvatar =
        this.personLists = this.personList;
        // console.log(this.personLists.account);
        // console.log(this.personList.account);
      } else {
        this.personLists = "";
      }
    },
    //去新闻中心列表
    news_list(id, name) {
      this.id = id;
      this.name = name;
      this.$router.push({
        name: "NewsCenter",
        query: { wid: this.id, name: this.name },
      });
      this.$store.commit("actives", "新闻中心");
    },
    //去解决方案
    solution_lists(id, name) {
      this.ids = id;
      this.names = name;
      this.$router.push({
        name: "SoluTion",
        query: { type: "solution", ids: this.ids, name: this.names },
      });
      this.$store.commit("actives", "解决方案");
    },
    //去关于我们
    about_list(id, name) {
      this.oid = id;
      this.oname = name;
      this.$router.push({
        name: "AboutUs",
        query: { type: "about", pid: this.oid, name: this.oname },
      });
      this.$store.commit("actives", "关于我们");
    },
    //去直线模组
    linecen(id) {
      this.Bus.$emit("chanpin", id);
      this.cid = id;
      this.$router.push({ name: "LineCenter", query: { oid: this.cid } });
      this.$store.commit("actives", "直线模组");
    },
    //热门搜索
    REMEN() {
      columnlist({ action: "getHotSearch" }).then(
        (res) => {
          this.REMENLIST = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //关闭
    close_show() {
      this.ISshow = false;
    },
    //更新选型计算数据
    updates() {
      var newpls_param = {
        action: "savePls",
        step: 2,
        pls_id: "",
        industry1: "",
        industry1_text: "",
        industry: "",
        industry_text: "",
        axis: "",
        axis_text: "",
        lcm: "",
        lcm_data: "",
        seriesData: "",
        step5data: "",
        step8data: "",
        step6data: "",
        tripL: "",
        seam: "",
        name: "",
        step7data: "",
        output: "",
      };
      this.$store.commit("newpls_param", newpls_param);
      this.$router.push({ name: "LectoType" });
      this.$store.commit("actives", "选型计算");
    },
    getToken() {
      this.token = getToken();
    },
    //失去焦点
    hidefocus() {
      // console.log('我是搜索框我失去焦点了');
    },
    //获取焦点
    showfocus() {
      this.ISshow = true;
    },
    //获取值
    getValue(value) {
      this.ISshow = false;
      this.searchValue = value;
    },
    //搜索
    search() {
      this.ISshow = false;
      if (this.searchValue != "") {
        if (this.History.length <= 9) {
          this.History.push(this.searchValue);
          this.history = this.History.join("|");
          setToken_history(this.history);
        } else {
          this.History.push(this.searchValue);
          this.history = this.History.join("|");
          this.history = this.history.substr(
            this.history.indexOf("|") + 1,
            this.history.length - 1
          );
          setToken_history(this.history);
        }
        this.$router.push({
          name: "NewsCenter",
          query: { types: this.searchValue },
        });
        this.searchValue = "";
      } else {
        this.common.TOAST("搜索内容不能为空", this);
      }
    },
    //头部栏目
    header_columm() {
      columnlist({ action: "column" }).then(
        (res) => {
          if (res.data.code == 1) {
            for (var i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].id == 58) {
                this.tabData = res.data.data[i].child[0];
                this.ids = res.data.data[i].child[0][0].id;
                this.names = res.data.data[i].child[0][0].name;
              } else if (res.data.data[i].id == 41) {
                this.tablist = res.data.data[i].child[0];
                this.id = res.data.data[i].child[0][0].id;
                this.name = res.data.data[i].child[0][0].name;
              } else if (res.data.data[i].id == 59) {
                this.aboutData = res.data.data[i].child[0];
                this.oid = res.data.data[i].child[0][0].id;
                this.oname = res.data.data[i].child[0][0].name;
              }
            }
            // console.log(res.data.data)
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //产品列表分类
    goodsLists() {
      let params = {
        action: "column",
      };
      goodsList(params).then(
        (res) => {
          this.goodtab = res.data.data;
          this.cid = "";
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //去我的消息
    to_news() {
      this.$router.push({ name: "News" });
    },
    //去首页
    to_home() {
      this.$router.push({ name: "home" });
      this.$store.commit("actives", "首页");
    },
    //去服务与支持
    to_service() {
      this.$router.push({ name: "ServiceSupport" });
      this.$store.commit("actives", "服务与支持");
    },
  },
  mounted() {
    removeToken_history();
    this.$store.dispatch("getData");
    setTimeout(() => {
      this.personData();
    }, 500);
    this.REMEN();
    this.header_columm();
    this.goodsLists();
    if (getToken_history() != undefined) {
      this.History = getToken_history().split("|");
    }
    this.token = getToken();
  },
  created() {
    router.beforeEach((to, from, next) => {
      this.token = getToken();
      this.$store.dispatch("getData");
      setTimeout(() => {
        this.personData();
      }, 500);
      if (getToken_history() != undefined) {
        this.History = getToken_history().split("|");
      }
      next();
    });
  },
  computed: {
    personList() {
      return this.$store.state.dataList;
    },
    actives() {
      return this.$store.state.actives;
    },
  },
  beforeDestroy() {
    this.Bus.$off("chanpin");
  },
  watch: {
    searchValue() {
      if (this.searchValue != "") {
        this.ISshow = false;
      }
    },
    $route() {
      this.Bus.$on("add", (message) => {
        if (message == "likaile") {
          this.searchValue = "";
        }
      });
      this.Bus.$on("upload", (message) => {
        if (message == "upload") {
          this.$store.dispatch("getData");
          setTimeout(() => {
            this.personData();
          }, 500);
        }
      });
    },
    // token(){
    //   if(this.getToken!=''){
    //         console.log('变化了')
    //         // this.$nextTick(()=> {
    //         　　this.personData()
    //         console.log(12)
    //         // })
    //   }
    // }
  },
};
</script>

<style scoped lang="scss">
@import "../../../static/css/common.scss";
.header_frame {
  height: 70px;
  line-height: 70px;
  background: $white;
  div {
    img {
      width: 120px;
      height: 40px;
      vertical-align: middle;
      margin: auto;
      cursor: pointer;
    }
    ul {
      width: 720px;
      float: right;
      margin-right: 40px;
      .link {
        display: inline-block;
        padding: 0px 15px;
        box-sizing: border-box;
        cursor: pointer;
        text-decoration: none;
        color: #000;
        position: relative;
        height: 70px;
        font-weight: bold;
        .header_box {
          width: 200%;
          background: white;
          position: absolute;
          top: 70px;
          z-index: 9999;
          color: #333333;
          text-align: left;
          left: 0px;
          box-shadow: 0px 0px 28px 1px rgba(126, 126, 126, 0.15);
          display: none;
          box-sizing: border-box;
          padding: 0px -20px;
          & > div {
            height: 40px;
            line-height: 40px;
            font-weight: normal;
            box-sizing: border-box;

            padding-left: 20px;
          }
          & > div:hover {
            color: $white;
            background: $blue;
          }
        }
      }
      .link:hover {
        background: $blue;
        color: $white;
      }
      .link:hover .header_box {
        display: block;
      }
    }
    .search {
      float: right;
      width: 200px;
      height: 30px;
      position: relative;
      input {
        width: 150px;
        height: 30px;
        border: 1px solid $border;
        text-indent: 5px;
        display: inline-block;
        background: $border;
        // border-radius: 5px;
      }
      button {
        width: 40px;
        height: 32px;
        background: $blue;
        color: $white;
        display: inline-block;
        margin-left: -10px;
        line-height: 32px;
        // border-top-right-radius: 5px;
        // border-bottom-right-radius: 5px;
      }
    }
    .header_right {
      width: 105px;
      height: 70px;
      float: right;
      .img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 20px;
        float: left;
        margin-top: 15px;
      }
      .head {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        float: right;
        margin-top: 15px;
      }
    }
  }
  .header_search {
    width: 200px;
    // height: 100px;
    line-height: 0px;
    background: white;
    // border-radius: 5px;
    z-index: 9999;
    position: absolute;
    top: 70px;
    left: 0;
    box-shadow: 0px 0px 28px 1px rgba(126, 126, 126, 0.15);
    box-sizing: border-box;
    padding: 0px 10px 10px 10px;
    .search_title {
      width: 100%;
      height: 20px;
      line-height: 20px;
      color: #b2b7bb;
      margin: 10px 0px;
    }
    .search_content {
      color: #5c5e5c;
      width: 50%;
      height: 20px;
      line-height: 20px;
      margin: 10px 0px;
      display: inline-block;
      cursor: pointer;
    }
  }
  .header_close {
    width: 30px;
    height: 30px;
    float: right;
    margin-top: 5px;
  }
}
.router-link-active {
  background: $blue !important;
  color: $white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Module1/headers.vue